import * as braze from '@braze/web-sdk'
import { actionCreatorAsync } from 'client/actions/index'

const getBrazeConfig = () => {
  const apiKey = window.initialConfiguration?.brazeApiKey || ''
  const sdkEndpoint = window.initialConfiguration?.brazeSdkEndpoint || ''

  if (!apiKey) {
    console.error('Braze API key is missing.')
  }

  if (!sdkEndpoint) {
    console.error('Braze SDK endpoint is missing.')
  }

  return {
    apiKey,
    sdkEndpoint,
    enableLogging: process.env.NODE_ENV === 'development',
    allowUserSuppliedJavascript: true,
  }
}

const startBrazeSession = ({ company, settings, token }) => {
  const config = getBrazeConfig()
  if (!config || !config.apiKey || !config.sdkEndpoint) {
    return false
  }

  if (company.randomBucket >= 0 && token.userId && settings) {
    try {
      braze.initialize(config.apiKey, {
        baseUrl: config.sdkEndpoint,
        enableLogging: config.enableLogging,
        allowUserSuppliedJavascript: config.allowUserSuppliedJavascript,
      })

      braze.automaticallyShowInAppMessages()
      braze.openSession()
    } catch (error) {
      console.error('Failed to start Braze session: ', error)
    }
  }
}

const setBrazeUserIdentity = ({ company, token, userGlobalId }) => {
  try {
    braze.changeUser(userGlobalId)

    const brazeUser = braze.getUser()
    if (!brazeUser) {
      console.error('Unable to get Braze user instance')
      return
    }

    const { language, firstName, lastName } = company
    const { email } = token

    brazeUser.setEmail(email)
    brazeUser.setFirstName(firstName)
    brazeUser.setLastName(lastName)
    brazeUser.setLanguage(language)
  } catch (error) {
    console.error('Failed to set Braze user identity: ', error)
  }
}

export const initializeBraze = () => {
  return async (dispatch, getState) => {
    await dispatch(
      actionCreatorAsync('INITIALIZE_BRAZE', async () => {
        const { company, settings, token } = getState()
        const userGlobalId = token?.['custom:globalId']

        if (!userGlobalId) {
          console.error('globalId is missing. Skipping Braze initialization.')
          return
        }

        if (!braze.isInitialized()) {
          startBrazeSession({ company, settings, token })
        }

        setBrazeUserIdentity({ company, token, userGlobalId })
      }),
    )
  }
}
